__webpack_require__.p = "/Graphs-Ising/";